export default {"src":"/_next/static/media/zadroLogo.e5c795bd.svg","height":457,"width":350};